import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import downloadIcon from './download.svg'
import styles from './index.styles'
import { CtaPageConfig } from '../configuration'
const useStyles = makeStyles(styles)

export default function Cta() {
    const classes = useStyles()
    return (
        <div className={classes.root} id="télécharger">
            <h1 className={classes.h1} >{CtaPageConfig.title}</h1>
            <span className={classes.btnWrap} >
                <a
                	target="_blank"
					href= {CtaPageConfig.url}
                    className={classes.btn}
                    variant='outlined'
                >	
                    {CtaPageConfig.cta} &nbsp; <img className={classes.btnIcon} src={downloadIcon} alt='download icon' />
                </a>
            </span>
        </div>
    )
}